// ApplicationTypeManagement.tsx

import * as React from 'react';
import ApplicationTypeList from './Components/ApplicationTypeList';
import CustomMenu from '../../components/CustomMenu/CustomMenu';

/**
 * 申請種別管理ページコンポーネント
 * - カスタムメニュー内に申請種別一覧を表示する
 */
export default function ApplicationTypeManagement() {
  return (
    <CustomMenu>
      <ApplicationTypeList />
    </CustomMenu>
  );
}
